module.exports = "<div class=\"container\">\r\n    <img src=\"./assets/img/error.svg\">\r\n    <span>{{'error' | translate}} {{message}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/betting/error/error-message.component.html
// module id = ../../../../../src/app/betting/error/error-message.component.html
// module chunks = 1